import { booleanToFormBoolean, formBooleanToBoolean } from "Utils/formUtils";
import { isDefined, isEmpty } from "Utils/functions";

import { Option } from "@storeblocks/radio";
import { BooleanOption, NumericOption } from "./radioTypes";

export const mapStringOptionToBooleanOption = (
  option: Option,
): BooleanOption => ({
  ...option,
  value: isEmpty(option.value) ? undefined : formBooleanToBoolean(option.value),
});

export const mapBooleanOptionToStringOptiton = (
  option: BooleanOption,
): Option => ({
  ...option,
  value: isDefined(option.value) ? booleanToFormBoolean(option.value) : "",
});

export const mapStringOptionToNumericOption = (
  option: Option,
): NumericOption => ({
  ...option,
  value: isEmpty(option.value) ? undefined : Number(option.value),
});

export const mapNumericOptionToStringOption = (
  option: NumericOption,
): Option => ({
  ...option,
  value: isDefined(option.value) ? String(option.value) : "",
});
